

import { AjaxGet, AjaxPost, Alert } from "../App.vue";
import Client from "../../../shared/Client";
import { GetAllClientURL, GetClientURL, GetNoteURL } from "../../../shared/Shared";
import Vue from "vue";
import ClientInfo from "../components/ClientInfo.vue";
import Notes from "../components/Notes.vue";
import Note from "../../../shared/Note";

class ClientsData {
    public ClientNames: string[] = [];
    public ClientData: Client | null = null;
    public SelectedClient = "";
    public ChangeCount = 0;
    public isDirty = false;
}

export default Vue.extend({
    name: "Clients",
    components: {
        ClientInfo,
        Notes,
    },

    created() {
        this.initialise();
    },

    data() {
        return new ClientsData();
    },
    computed: {
        noteURL(): string {
            return GetNoteURL(this.SelectedClient);
        }
    },
    methods: {

        save() {
            this.isDirty = false;
            AjaxPost(GetClientURL(this.SelectedClient), this.ClientData, true).catch((err) => {
                Alert("Client save error", err);
            }).finally(() => {
                this.setSelectedClient(this.SelectedClient);
            });
        },

        change() {
            this.isDirty = true;
            this.$forceUpdate();
        },

        setSelectedClient(value: string) {
            if (this.isDirty) {
                if (
                    confirm(
                        this.SelectedClient +
                        " is not saved. OK = Save changes. Cancel = Discard changes."
                    )
                ) {
                    this.save();
                } else {
                    this.isDirty = false;
                    this.setSelectedClient(value);
                }
                return;
            }

            // Load the client
            AjaxGet<Client>(GetClientURL(value), true).then((data) => {
                this.ClientData = data;
                this.SelectedClient = value;
                this.ChangeCount++;
            });

        },

        initialise() {
            AjaxGet<{ [key: string]: Client } | null>(
                GetAllClientURL(),
                true
            ).then((data) => {

                if (!data || Object.keys(data).length < 1) {
                    return;
                }
                this.ClientNames = Object.keys(data);
                this.setSelectedClient(this.ClientNames[0]);

            });
        },
    }
});


